module.exports = __webpack_public_path__ + "media/Bip.a14774ef.wav";